import { render, staticRenderFns } from "./AddSpecialty.vue?vue&type=template&id=34afc95e&scoped=true"
import script from "./AddSpecialty.vue?vue&type=script&lang=js"
export * from "./AddSpecialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34afc95e",
  null
  
)

export default component.exports